import { render, staticRenderFns } from "./TableSortingHelper.vue?vue&type=template&id=5c6b72e4&"
import script from "./TableSortingHelper.vue?vue&type=script&lang=js&"
export * from "./TableSortingHelper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports